<!-- Contenedor principal -->
<div class="card-header mb-4">
  <div class="title-section">
    <h2 class="header-title">Tasas</h2>
  </div>
  <div class="search-section">
    <div class="button-section">
      <span class="p-input-icon-left search-input">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="dt?.filterGlobal($any($event.target).value, 'contains')" placeholder="Buscar..." class="p-inputtext-sm" appPermissionControl="P154K0001" />
      </span>
      <button mat-flat-button (click)="openCreate()" class="btn-new" appPermissionControl="P154B0001">
        <mat-icon>add</mat-icon>
        Nuevo
      </button>
    </div>
  </div>
</div>

<p-table
  #dt
  [value]="dataSource.data"
  [columns]="displayedColumns"
  [paginator]="true"
  [rows]="10"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 15, 20]"
  [scrollable]="true"
  scrollHeight="400px"
  styleClass="p-datatable-gridlines"
  [resizableColumns]="true"
  [autoLayout]="true"
  responsiveLayout="scroll"
  [loading]="loading"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  appPermissionControl="P154T0001"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P154C0001">
        {{ col.header }}
        <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" class="td-prime">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'actions'">
            <div class="d-flex gap-2 justify-content-center">
              <button pButton icon="pi pi-eye" class="p-button-rounded p-button-info p-button-text" (click)="openUpdate(rowData)" pTooltip="Editar" appPermissionControl="P154B0002"></button>
              <button
                pButton
                icon="pi pi-history"
                class="p-button-rounded p-button-info p-button-text"
                (click)="openHistorical(rowData)"
                pTooltip="Histórico"
                appPermissionControl="P154B0003"
              ></button>
              <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="delete(rowData)" pTooltip="Eliminar" appPermissionControl="P154B0004"></button>
            </div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{ rowData[col.field] }}
          </ng-container>
        </ng-container>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" class="text-center td-prime">No hay datos para mostrar</td>
    </tr>
  </ng-template>
</p-table>

<p-toast position="bottom-right"></p-toast>